import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { WsService } from '../ws/ws.service';
import { StatService } from '../stat/stat.service';
import timeGridPlugin from '@fullcalendar/timegrid';

import { WorkflowService } from '../workflow/workflow.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private stateSubscription: Subscription;
  private workmodeSubscription: Subscription;
  private userSubscription: Subscription;
  private schedulesSubscription: Subscription;
  private connectSubscription: Subscription;
  private calendarDate: any;
  public state: any;
  public user: any;
  public workmode: any;
  public ST: any;
  public WM: any;
  public schedules: any;
  public calendarPlugins = [timeGridPlugin];
  public stats: any;
  public pauseLocked: boolean;

  constructor(private ws: WsService, private ss: StatService, private wf: WorkflowService) {
      this.ST = this.ws.ST;
      this.WM = this.ws.WM;
      this.stateSubscription = this.ws.onState.subscribe(this.onChangeState.bind(this));
      this.userSubscription = this.ws.onUser.subscribe(this.onChangeUser.bind(this));
      this.workmodeSubscription = this.ws.onWorkMode.subscribe(this.onChangeWorkMode.bind(this));
      this.schedulesSubscription = this.ws.events.schedule_list.subscribe(this.onSchedules.bind(this));
      this.connectSubscription = this.ws.onConnect.subscribe(this.onConnect.bind(this));
      this.state = this.ws.getState();
      this.user = this.ws.getUser();
      this.workmode = this.ws.getWorkMode();
      this.stats = this.ss.getStats();
      this.calendarDate = null;
      this.pauseLocked = false;
      this.initStats();
  };

  private onChangeState(state: number): void {
      this.state = state;
      this.stats = this.ss.getStats();
      this.pauseLocked = false;
  };

  private onChangeUser(user: any): void {
      this.user = user;
      this.initStats();
  };

  private onChangeWorkMode(mode: string): void {
      this.workmode = mode;
  };

  private initStats(): void {
      this.schedules = [];
      this.stats = this.ss.getStats();
  };

  private onSchedules(data: any): void {
      this.schedules = [];
      if (this.user && data.SCHEDULES) {
          this.user.schedules = data.SCHEDULES;
          this.schedules = data.SCHEDULES.map(this.preProcessSchedule.bind(this));
      }
  };

  public onCalendarDatesChange(changeEvent: any): void {
      if (!changeEvent) {
          return;
      }
      const eventDate = this.formatServerDate(changeEvent.view.currentStart);
      if (eventDate === this.calendarDate) {
          return;
      }
      this.calendarDate = eventDate;
      this.ws.methodListSchedules({from: this.calendarDate});
  };

  private onConnect(): void {
      this.pauseLocked = false;
  };

  private preProcessSchedule(schedule: any): any {
      if (!schedule) {
          return schedule;
      }
      schedule.start = this.parseServerDate(schedule.DT_FROM);
      schedule.end = this.parseServerDate(schedule.DT_TO);
      schedule.id = schedule.ID;
      return schedule;
  };

  private formatServerDate(d: any): any {
      if (!d || !d.toISOString) {
          return '';
      }
      const isoString = d.toISOString();
      return isoString.substring(8, 10) + '.' + isoString.substring(5, 7) + '.' + isoString.substring(0, 4);
  };

  private parseServerDate(d: any): any {
      if (!d) {
          return '';
      }
      // 11.02.2020 1:00:00
      const dateFields = d.split(/[\. :]/);
      let isoDate =  dateFields[2] + '-' + dateFields[1].padStart(2, '0') + '-' + dateFields[0].padStart(2, '0');
      if (dateFields.length > 3) {
          isoDate += ' ' + dateFields[3].padStart(2, '0') + ':' + dateFields[4].padStart(2, '0') + ':' + dateFields[5].padStart(2, '0') + 'Z';
      } else {
          isoDate += ' 00:00:00';
      } 
      return isoDate;
  };

  public setPause(pauseState: boolean): void {
      if (!this.pauseLocked) {
          this.pauseLocked = true;
          this.ws.methodPause(pauseState);
      }
  };

  public testCall(): void {
      this.ws.methodTestCall();
  };

  ngOnInit() {
  };

  ngOnDestroy() {
      this.stateSubscription.unsubscribe();
      this.userSubscription.unsubscribe();
      this.workmodeSubscription.unsubscribe();
      this.schedulesSubscription.unsubscribe();
      this.connectSubscription.unsubscribe();
  };

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts